import { render, staticRenderFns } from "./NflTeamDepth.vue?vue&type=template&id=67bd0f1e"
import script from "./NflTeamDepth.vue?vue&type=script&lang=js"
export * from "./NflTeamDepth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports